<!--suppress ALL -->
<template>
	<v-select
		name="client_id"
		:items="options"
		v-model="model"
		item-text="name"
		item-value="id"
		:label="labelText"
		:disabled="disable"
		:clearable="clearable"/>
</template>

<script>
	import ClientModule from "src/store/modules/Client.module";
	import SelectMixin from "src/mixins/SelectMixin";

	export default {
		name: "clients-select",
		props: {
			value: {default: null},
			clearable: {default: true},
			label: {type: String, default: ""},
			disable: {default: false}
		},
		computed: {
			labelText() {

				return this.label || this.$t("attributes.select");
			}
		},
		methods: {},
		components: {},
		mixins: [new SelectMixin(ClientModule, "clients")],

	};
</script>
